import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Modal, Btn } from "@/components/erp/ui";
import { ArrowUp, ArrowDown, RotateCcw } from "lucide-react";

export const menuKey = (i) => i.to || `g:${i.group}`;

export const applyOrder = (menu, order) => {
  if (!order?.length) return menu;
  const pos = new Map(order.map((k, i) => [k, i]));
  return menu.map((m, i) => ({ m, k: pos.has(menuKey(m)) ? pos.get(menuKey(m)) : order.length + i })).sort((a, b) => a.k - b.k).map((x) => x.m);
};

export const MenuOrderModal = ({ menu, close, saved }) => {
  const [list, setList] = useState(menu);
  const [busy, setBusy] = useState(false);
  const move = (i, d) => { const j = i + d; if (j < 0 || j >= list.length) return; const n = [...list]; [n[i], n[j]] = [n[j], n[i]]; setList(n); };
  const save = async (order) => {
    setBusy(true);
    try { await api.put("/settings/menu-order", { order }); toast.success("Urutan menu disimpan \u2014 berlaku untuk semua akun"); saved(order); close(); } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
    setBusy(false);
  };
  return (
    <Modal open onClose={close} title="Atur Urutan Menu"
      footer={<><Btn variant="ghost" data-testid="menu-order-reset" onClick={() => save([])} disabled={busy}><RotateCcw className="w-4 h-4" /> Urutan awal</Btn><Btn data-testid="menu-order-save" onClick={() => save(list.map(menuKey))} disabled={busy}>Simpan</Btn></>}>
      <p className="text-xs text-slate-500 mb-3">Geser naik/turun. Pindahkan menu melewati judul grup untuk memindah grupnya. Berlaku untuk semua akun (menu tetap hanya tampil sesuai hak akses).</p>
      <div className="max-h-[55vh] overflow-y-auto space-y-1" data-testid="menu-order-list">
        {list.map((i, k) => (
          <div key={menuKey(i)} data-testid={`menu-order-item-${k}`} className={`flex items-center gap-2 px-2 py-1.5 rounded-lg ${i.group ? "bg-slate-900 text-white text-[11px] font-mono uppercase" : "bg-slate-50 text-sm"}`}>
            <span className="flex-1 truncate">{i.group || i.label}</span>
            <button type="button" aria-label="naik" data-testid={`menu-order-up-${k}`} onClick={() => move(k, -1)} className="p-1 rounded hover:bg-slate-200/40"><ArrowUp className="w-3.5 h-3.5" /></button>
            <button type="button" aria-label="turun" data-testid={`menu-order-down-${k}`} onClick={() => move(k, 1)} className="p-1 rounded hover:bg-slate-200/40"><ArrowDown className="w-3.5 h-3.5" /></button>
          </div>
        ))}
      </div>
    </Modal>
  );
};
